import { useEffect, useState } from "react";
import { ENDPOINTS } from "services";

import styles from "./login.module.css";

export const BgLogo = () => {
  const [bgLogoSrc, setBgLogoSrc] = useState<string | null>(null);

  useEffect(() => {
    setBgLogoSrc(ENDPOINTS.fileFromCloud("bg-logo.svg"));
  }, []);

  return bgLogoSrc ? <img src={bgLogoSrc} alt="VED logo" className={styles.loginBackground} /> : null;
};
